import { render, staticRenderFns } from "./OnDemandAvgWatchTime.vue?vue&type=template&id=724bfa04&scoped=true&"
import script from "./OnDemandAvgWatchTime.vue?vue&type=script&lang=js&"
export * from "./OnDemandAvgWatchTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "724bfa04",
  null
  
)

export default component.exports